import { LoaderDetailsType } from '../types/LoaderDetailsType';

export type LoaderState = {
    loaderDetails: LoaderDetailsType[];
};

export type LoaderAction = {
    type: 'add' | 'remove' | 'reset';
    loaderDetail?: LoaderDetailsType;
    endpoint?: string;
    additionalLoaderData?: any;
};

export default (state: LoaderState, action: LoaderAction): LoaderState => {
    switch (action.type) {
        case 'add': {
            const _loaders = [...state.loaderDetails];
            _loaders.push(action.loaderDetail);
            return {
                loaderDetails: [..._loaders],
            };
        }
        case 'remove': {
            const _loaderDetails = action.additionalLoaderData
                ? [
                      ...[...state.loaderDetails].filter(
                          (l) => !(l.endpoint === action.endpoint && Object.is(l.additionalLoaderData, action.additionalLoaderData))
                      ),
                  ]
                : [...[...state.loaderDetails].filter((l) => l.endpoint !== action.endpoint)];

            return {
                loaderDetails: [..._loaderDetails],
            };
        }
        default:
            return state;
    }
};
